export default __webpack_public_path__ + "static/media/2_2.6d879943.jpg";